import React from 'react';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';
import * as authActions from '../auth.actions';
import { withRouter, Route } from 'react-router-dom';
import validate from 'validate.js';
import isEmpty from 'lodash/isEmpty';
import Button from 'material-ui/Button';
import { NavLink } from 'react-router-dom';
import Paper from 'material-ui/Paper';
import { withStyles } from 'material-ui/styles';
import groupBy from 'lodash/groupBy';
import keys from 'lodash/keys';
import { FormHelperText } from 'material-ui/Form';
import ForgotPasswordDialog from '../../user/components/ForgotPasswordDialog';
import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons/Icons';
import Typography from 'material-ui/Typography';
import colors from '../../../ui/colors';
const styles = theme => ({
  root: {
    maxWidth: 400,
    margin: theme.spacing.unit * 3 + 'px auto',
    padding: theme.spacing.unit * 3,
    textAlign: 'left',
  },
  input: {
    width: '100%',
  },
  forgot: {
    flex: 1,
    color: colors.GREEN_BRIGHT,
  },
  flexRow: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
});

validate.formatters.custom = function(errors) {
  const errorsByKey = groupBy(errors, 'attribute');
  const errorObj = {};
  keys(errorsByKey).forEach(key => {
    errorObj[key] = errorsByKey[key][0].error;
  });
  return errorObj;
};

class LoginForm extends React.Component {
  constructor(props) {
    super(props);

    const formData = {
      email: '',
      password: '',
    };

    this.state = {
      ...this.state,
      errors: {},
      formData,
      touchedFields: [],
      isLoading: false,
      isValid: false,
      resetPasswordOpen: false,
    };
  }

  validate = () => {
    const { formData } = this.state;
    const constraints = {
      email: {
        email: true,
      },
      password: {
        presence: true,
      },
    };
    const errors = validate(formData, constraints, { format: 'custom' }) || {};
    const isValid = isEmpty(errors);
    this.setState({
      errors,
      isValid,
    });
  };

  onBlur = event => {
    this.updateTouchedfields(event);
    this.validate();
  };

  updateTouchedfields(event) {
    const { name } = event.target;
    if (name === '') return;
    const touchedFields = [...this.state.touchedFields.filter(item => item !== name), name];
    this.setState({
      touchedFields,
    });
  }

  onForgotPasswordClose = () => {
    const { history } = this.props;
    history.replace('/');
  };

  onInputChange = event => {
    if (event.target.name === '') return;
    const { formData } = this.state;
    const updatedFormData = {
      ...formData,
      [event.target.name]: event.target.value,
    };

    this.setState(
      {
        formData: updatedFormData,
      },
      () => {
        this.validate();
      }
    );
  };

  onKeyPress = event => {
    if (event.charCode === 13) {
      // enter key pressed
      event.preventDefault();
      this.doSubmit();
    }
  };

  setErrorState = errorMsg => {
    this.setState({
      isLoading: false,
      isSubmitting: false,
      submitFailed: true,
      submitted: true,
      formError: errorMsg,
    });
  };

  doSubmit = () => {
    if (this.state.isValid) {
      const { loginUser } = this.props;
      const { formData } = this.state;
      this.setState({ isLoading: true });
      loginUser({
        username: formData.email,
        password: formData.password,
      })
        .then(action => {
          if (action && action.response && action.response.status && action.response.status === 'ok') {
          } else {
            let message = ' on virheellinen';
            if (action.error && action.error.message) {
              switch (action.error.message) {
                case 'This email is not registered.':
                  message = 'Sähköposti' + message;
                  break;
                case 'This password is not correct.':
                  message = 'Salasana' + message;
                  break;
                default:
                  message = 'Kirjautuminen ei onnistunut';
              }
            }
            this.setErrorState(message);
          }
        })
        .catch(error => {
          this.setErrorState(error);
        });
    }
  };

  render() {
    const { isValid, formData, errors, touchedFields, formError, isLoading } = this.state;
    const { classes } = this.props;
    return (
      <Paper className={classes.root}>
        <Icon icon={ICONS.LOGO} fill={colors.GREEN_DARK} width={'179px'} height={'12px'} />
        <Typography color="inherit" type="subheading">
          Kirjaudu sisään
        </Typography>

        <TextField
          label="Sähköposti"
          name="email"
          type="email"
          id="login-email"
          className={classes.input}
          value={formData.email}
          error={errors['email'] && touchedFields.indexOf('email') > -1}
          onChange={this.onInputChange}
          onBlur={this.onBlur}
          onKeyPress={this.onKeyPress}
        />
        <TextField
          label={'Salasana'}
          name="password"
          type="password"
          id="login-password"
          className={classes.input}
          value={formData.password}
          error={errors['password'] && touchedFields.indexOf('password') > -1}
          onChange={this.onInputChange}
          onBlur={this.onBlur}
          onKeyPress={this.onKeyPress}
        />
        <FormHelperText error>{formError}</FormHelperText>
        <div className={classes.flexRow}>
          <NavLink to="/resetPassword" className={classes.forgot}>
            Unohditko salasanan?
          </NavLink>
          <Route
            exact
            path="/resetPassword"
            parentPath="/"
            render={({ match, location, history }) => (
              <ForgotPasswordDialog onRequestClose={this.onForgotPasswordClose} />
            )}
          />
          <Button raised color="accent" id="login-submit" onClick={this.doSubmit} disabled={!isValid || isLoading}>
            Kirjaudu
          </Button>
        </div>
      </Paper>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const ConnectedLoginForm = connect(mapStateToProps, authActions)(LoginForm);

export default withRouter(withStyles(styles)(ConnectedLoginForm));



// WEBPACK FOOTER //
// ./src/modules/auth/components/LoginForm.js